<script setup lang="ts"></script>

<template>
  <div class="user-left-div" style="float: left">
    <table id="tblUserLeft">
      <tr>
        <th>Your Account Menu</th>
      </tr>
      <tr>
        <td>
          <router-link to="/UserInfo">
            <a class="inq-a-link">Profile Update</a>
          </router-link>
        </td>
      </tr>
      <tr>
        <td>
          <router-link to="/UserPermissionUpdate">
            <a class="inq-a-link">Menu Selection</a>
          </router-link>
        </td>
      </tr>
    </table>
  </div>
</template>

<style>
.user-left-div {
  display: inline-block;
  margin-top: 2%;
  vertical-align: top;
  margin-left: 1%;
  width: 15%;
  height: calc(100% - 140px);
}

#tblUserLeft {
  border-collapse: collapse;
  width: 100%;
  word-wrap: break-word;
}

#tblUserLeft th {
  width: 250px;
  background: #00368f;
  color: #ffffff;
  height: 50px;
  border: #ccc solid 0.1px;
  word-wrap: break-word;
  font-size: 1.2em;
}

#tblUserLeft td {
  width: 250px;
  text-align: left;
  border: #ccc solid 0.1px;
  height: 35px;
  word-wrap: break-word;
}

.inq-a-link {
  color: blue;
  font-size: 1em;
  word-wrap: break-word;
}
</style>
